<template>
    <div ref="formSectionRef"
         class="form-section border-b border-neutral-200 dark:border-neutral-800 flex"
         :class="[isMobile ? 'flex-col gap-4 py-6' : 'flex-row gap-8 py-10']"
    >
        <div :class="[!isMobile ? 'w-2/5' : null]">

            <template v-if="editable">

                <div class="actions flex items-center justify-end gap-x-3 mb-3">
                    <template v-for="action in actions">
                        <Button secondary outlined size="xs" @click="action.click">
                            <Tooltip :label="action.label" position="right">
                                <div class="p-0.5">
                                    <Icon :icon="action.icon"/>
                                </div>
                            </Tooltip>
                        </Button>
                    </template>
                </div>

                <div class="flex items-center">
                    <div class="flex-1">
                        <input type="text"
                               v-model="form.fields.name"
                               class="bg-transparent rounded p-0 border-0 w-full font-bold dark:hover:bg-neutral-800 hover:bg-neutral-200"
                               @blur="handleBlur"
                               @keydown.enter="handleBlur"
                        />
                    </div>

                </div>

                <div>
                    <TextareaInput :rows="1"
                                   v-model="form.fields.description"
                                   class="bg-transparent !p-0 border-0 w-full text-sm my-1.5 text-neutral-500 dark:hover:bg-neutral-800 hover:bg-neutral-200"
                                   @blur="handleBlur"
                    />
                </div>

            </template>

            <template v-else>
                <div class="font-bold">{{ title }}</div>
                <Help v-if="description">{{ description }}</Help>
            </template>

        </div>
        <div :class="[!isMobile ? 'w-3/5' : null]">
            <slot></slot>
        </div>
    </div>
</template>

<script>
import {Form} from '@/internal.js';

export default {
  name: 'FormSection',
  computed: {
    isMobile() {
      return this.width < 640;
    },
  },
  mounted() {
    this.resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        this.width = entry.contentRect.width;
      }
    });
    this.resizeObserver.observe(this.$refs.formSectionRef);
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },
  created() {
    this.form.fields = {
      name: this.title,
      description: this.description,
    };
  },
  data() {
    return {
      actions: [
        {
          click: () => {
            this.$emit('delete');
          },
          icon: 'trash-alt',
          label: 'Delete',
        },
      ],
      form: new Form({
        name: '',
        description: '',
      }),
      width: 0,
    };
  },
  methods: {
    handleBlur(event) {

      if (event.target.type === 'text') {
        event.target.blur();
      }

      if (this.name !== this.form.fields.name || this.description !== this.form.fields.description) {
        this.$emit('blur', {
          ...this.form.fields,
        });
      }

    },
    handleDelete() {

    },
  },
  props: {
    description: {
      required: true,
      type: String,
    },
    editable: {
      default: false,
      required: false,
      type: Boolean,
    },
    title: {
      required: false,
      type: String,
    },
  },
};
</script>

<style scoped lang="scss">
</style>
